import { PlusCircledIcon, UpdateIcon } from '@radix-ui/react-icons';
import { useState } from 'react';
import { Button } from '../ui/button';
import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogDescription, DialogHeader,
    DialogTitle,
    DialogTrigger
} from "../ui/dialog";
import { DropdownMenuItem } from "../ui/dropdown-menu";
import {
    Form,
    FormControl, FormField,
    FormItem,
    FormLabel,
    FormMessage
} from '../ui/form';

import { useForm } from 'react-hook-form';
import api from '../../lib/api';
import { Input } from '../ui/input';
import { toast } from '../ui/use-toast';

const CreateCupDialog = ({ competitionId, reloadCompetitionSingle }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [err, setError] = useState(null);
    const form = useForm();
    const [isDialogOpen, setIsDialogOpen] = useState(false);

    const [formData, setFormData] = useState({
        name: '',
        competitionId: competitionId,
    });

    if (!competitionId) {
        return null;
    }

    const handleChange = async (e) => {
        e.preventDefault();
        setError(null);
        setIsLoading(true);

        try {
            const response = await api.post(`https://skhrf-api.cmdigital.se/v1/cups/create`, {
                name: formData.name,
                competitionId: formData.competitionId,
            });

            reloadCompetitionSingle();

            toast({
                title: 'Cup skapad',
                description: `Cup med namn ${formData.name} har skapats.`,  // Using full class name
            });
            form.reset();  // Reset react-hook-form fields
            setFormData({
                name: '',
                competitionId: competitionId,
            });
            setIsLoading(false);
            setIsDialogOpen(false);
        } catch (error) {
            setError(error?.response?.data?.error);
            toast({
                variant: 'destructive',
                title: 'Något gick fel.',
                description: err,
            });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Dialog open={isDialogOpen} onOpenChange={setIsDialogOpen}>
            <DropdownMenuItem onSelect={(event) => event.preventDefault()}>
                <DialogTrigger className='flex items-center w-full'>
                    <PlusCircledIcon className='mr-3'/>
                    Skapa cup
                </DialogTrigger>
            </DropdownMenuItem>
            <DialogContent className="flex flex-col gap-6">
                <DialogHeader className='text-left'>
                    <DialogTitle>
                        Skapa cup
                    </DialogTitle>
                    <DialogDescription>
                        Ange information för att skapa en cup.
                    </DialogDescription>
                </DialogHeader>
                <Form {...form}>
                    <form onSubmit={handleChange} className="flex flex-col gap-6">
                        <FormField
                            control={form.control}
                            name="name"
                            render={({ field }) => (
                                <FormItem className='space-y-0 grid gap-2'>
                                    <FormLabel>Cupnamn</FormLabel>
                                    <FormControl>
                                        <Input
                                            placeholder="Stora cupen"
                                            {...field}
                                            value={formData.name}
                                            onChange={(e) => {
                                                field.onChange(e);
                                                setFormData(prevState => ({
                                                    ...prevState,
                                                    name: e.target.value,
                                                }));
                                            }}
                                            autoComplete='off'
                                        />
                                    </FormControl>
                                    <FormMessage />
                                </FormItem>
                            )}
                        />

                        <div className='grid grid-cols-2 gap-3'>
                            <DialogClose asChild>
                                <Button type='button' variant='secondary'>Avbryt</Button>
                            </DialogClose>
                            <Button
                                onClick={handleChange}
                                disabled={isLoading}>
                                {(isLoading) ? <UpdateIcon className='loader-spinner' /> : <>Skapa</>}
                            </Button>
                        </div>
                    </form>
                </Form>
            </DialogContent>
        </Dialog>
    );
};

export default CreateCupDialog;
